var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasoline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.922,
    height: 49.922,
    viewBox: "0 0 49.922 49.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M39.441,2H21.42a2.5,2.5,0,0,0-1.765.731L2.731,19.655A2.494,2.494,0,0,0,2,21.42V44.434a7.5,7.5,0,0,0,7.488,7.488H49.426a2.5,2.5,0,0,0,2.5-2.5V14.48A12.5,12.5,0,0,0,39.441,2ZM46.93,46.93H9.488a2.5,2.5,0,0,1-2.5-2.5V22.454L22.454,6.992H39.441A7.5,7.5,0,0,1,46.93,14.48ZM6.261,13.749l7.488-7.488a2.5,2.5,0,1,0-3.53-3.53L2.731,10.22a2.5,2.5,0,1,0,3.53,3.53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M26.225,5H16.24a6.24,6.24,0,0,0,0,12.48h9.984a6.24,6.24,0,0,0,0-12.48Zm0,7.488H16.24a1.248,1.248,0,0,1,0-2.5h9.984a1.248,1.248,0,0,1,0,2.5Zm1.979,8.22L22.48,26.431l-5.724-5.723a2.5,2.5,0,1,0-3.53,3.53l5.724,5.723-5.723,5.724a2.5,2.5,0,1,0,3.53,3.53l5.723-5.724L28.2,39.214a2.5,2.5,0,1,0,3.53-3.53L26.01,29.961l5.723-5.724a2.5,2.5,0,1,0-3.53-3.53Z",
    transform: "translate(11.969 4.488)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasoline);
export default __webpack_public_path__ + "static/media/gasoline.1443c7c18b5bd31436a125889483916e.svg";
export { ForwardRef as ReactComponent };